// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1ULKI","label":"Completed_label__1Dzhx"};